import { render } from "./Scan.vue?vue&type=template&id=2341824c&scoped=true"
import script from "./Scan.vue?vue&type=script&lang=ts"
export * from "./Scan.vue?vue&type=script&lang=ts"

import "./Scan.vue?vue&type=style&index=0&id=2341824c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2341824c"

export default script